// eslint-disable-next-line max-classes-per-file
export class MollieTerminalBankType {
	TerminalID:string = "";
	BankTypeID:number = 0;

	public constructor(data?:any){
		if (!data) return;
		this.TerminalID = data.TerminalID || "";
		this.BankTypeID = data.BankTypeID || 0;
	}
}

export class MollieConfig {
	BankID:number = 1;
	ConnectedWithMollie:boolean = false;
	ProfileID:string = "";
	TerminalBankTypes:MollieTerminalBankType[] = [];

	public constructor(data?:any){
		if (!data) return;
		this.BankID = data.BankID;
		this.ConnectedWithMollie = data.ConnectedWithMollie;
		this.ProfileID = data.ProfileID;
		this.TerminalBankTypes = ((data.TerminalBankTypes || []) as any[]).map(t => new MollieTerminalBankType(t));
	}

	public getBankTypeIdForTerminal(terminalId:string):number {
		let found = this.TerminalBankTypes.find(t => t.TerminalID == terminalId);
		if (!found) return 0;
		return found.BankTypeID;
	}

	public setBankTypeIdForTerminal(terminalId:string, bankTypeId:number){
		let found = this.TerminalBankTypes.find(t => t.TerminalID == terminalId);
		if (found) {
			found.BankTypeID = bankTypeId;
			return;
		}
		let entry = new MollieTerminalBankType();
		entry.TerminalID = terminalId;
		entry.BankTypeID = bankTypeId;
		this.TerminalBankTypes.push(entry);
	}

	public getJSON():any{
		return {
			BankID: this.BankID,
			ProfileID: this.ProfileID,
			TerminalBankTypes: this.TerminalBankTypes.map(t => {
				return {
					TerminalID: t.TerminalID,
					BankTypeID: t.BankTypeID
				};
			})
		};
	}
}
